import { useState, useEffect } from 'react';
import type { SandboxBadge } from '../types/sandbox';
import { supabase } from '../lib/supabase';
import { getMockBadges } from '../lib/mock-data';

export function useBadges(operatorDid?: string) {
  const [badges, setBadges] = useState<SandboxBadge[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!operatorDid) {
      setBadges([]);
      setLoading(false);
      return;
    }

    const load = async () => {
      setLoading(true);

      try {
        if (supabase) {
          const { data } = await supabase
            .from('sandbox_badges')
            .select('*')
            .eq('operator_did', operatorDid)
            .order('earned_at', { ascending: false });
          setBadges((data || []) as SandboxBadge[]);
        } else {
          setBadges(getMockBadges(operatorDid));
        }
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [operatorDid]);

  return { badges, loading };
}
